module.exports = __webpack_public_path__ + "img/Convertibles_disabled.d456d501.svg";